module.exports = __webpack_public_path__ + "img/plan_t2.c279ccfb.webp";